import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { environment } from 'src/environments/environment';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public auth: AuthenticationService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Do not attach Authorization to login/social-login endpoints.
    // Otherwise a stale JWT can break auth flows (and may trigger forced redirects).
    const isJwtCreate = request.url.startsWith(environment.apiUrl + '/auth/jwt/create/');
    const isJwtRefresh = request.url.startsWith(environment.apiUrl + '/auth/jwt/refresh/');
    const isJwtVerify = request.url.startsWith(environment.apiUrl + '/auth/jwt/verify/');

    if (request.url === this.auth.loginUrl || isJwtCreate || isJwtRefresh || isJwtVerify) {
      request = request.clone();
      return next.handle(request);
    } else {
      const token = this.auth.getToken();
      if (!token) return next.handle(request);

      // If access token is expired/malformed, try refresh once before sending request.
      if (this.auth.isAccessTokenExpired()) {
        return this.auth.refreshToken().pipe(
          switchMap(newToken => {
            if (!newToken) {
              // Refresh failed -> don't send request with stale JWT (avoids token_not_valid noise).
              return next.handle(request);
            }
            const authed = request.clone({
              setHeaders: { Authorization: `JWT ${newToken}` },
            });
            return next.handle(authed);
          })
        );
      }

      const authed = request.clone({
        setHeaders: { Authorization: `JWT ${token}` },
      });
      return next.handle(authed);
    }
  }
}
